<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
    <b-row class="justify-content-center">
            <b-col md="7" class="mt-3" v-if="auftrag.id !== 'testid'">
                <b-card-group>
                    <b-card id="auftrag1" ref="el">
                        <div slot="header"
                             style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
                            Auftrag an: <strong>{{auftrag.a_nehmer}}</strong>
                        </div>
                        <b-row style="border-bottom: 1px solid #ccc!important;">
                            <b-col sm="6">
                                <b-form-group
                                        label="Auftraggeber:"
                                        label-for="auftraggeber"
                                >
                                    <b-form-input
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                            disabled
                                            id="auftraggeber"
                                            type="text"
                                            :placeholder="auftrag.auftraggeber"
                                            v-model="auftrag.auftraggeber"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group
                                        label="Zieltermin an/bis:"
                                        label-for="date"
                                >
                                    <datetime
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                            :disabled="isEditMode"
                                            v-model="auftrag.ziel_datum"
                                            input-class="form-control"
                                            input-style="color: black;"
                                            input-id="date"
                                            :aria-placeholder="formateDate"
                                            :phrases="datetimeConfig.phrases"
                                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                            :min-datetime="datetimeConfig.minTime"></datetime>

                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col>
                                <b-form-group
                                        label="Zahlungspflichtiger/Buchungsstelle:"
                                        label-for="hh"
                                >
                                    <b-form-input
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                            disabled
                                            id="hh"
                                            type="text"
                                            v-model="auftrag.gi_hh_aus"
                                            :placeholder="auftrag.gi_hh_aus"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-0" style="border-bottom: 1px solid #ccc!important;">
                            <b-col>
                                <b-form-group
                                        label="Belegnummer:"
                                        label-for="bnr"
                                >
                                    <b-form-input
                                            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                            disabled
                                            id="bnr"
                                            type="text"
                                            v-model="auftrag.beleg_ex"
                                            :placeholder="auftrag.beleg_ex"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2">
                                <p class="p-center">Auftragstitle:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        class="bold-text"
                                        :disabled="true"
                                        type="text"
                                        v-model="auftrag.gi_auf_ext"
                                        :placeholder="auftrag.gi_auf_ext"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="2">
                                <p class="p-center">Suchbegriff:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="auftrag.gi_match"
                                        :placeholder="auftrag.gi_match"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="2">
                                <p class="p-center">Auftragsnummer:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="a_nr"
                                        :placeholder="a_nr"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                        <b-row v-if="hasContact">
                            <b-col sm="2">
                                <p class="p-center">Für Rückfragen:</p>
                            </b-col>
                            <b-col>
                                <b-form-textarea
                                        class="text-black"
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                        disabled
                                        type="text"
                                        v-model="contact"
                                        :placeholder="contact"
                                        wrap="hard"
                                        rows="3"
                                        :max-rows="maxrows"
                                >
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2"></b-col>
                            <b-col>
                                <b-form-textarea id="info-box" ref="infoBox"
                                                 class="text-black"
                                                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                                                 :placeholder="auftrag.gi_memo"
                                                 :rows="4"
                                                 :max-rows="maxrows"
                                                 wrap="hard"
                                                 :disabled="isEditMode"
                                                 v-model="auftrag.gi_memo"

                                ></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3" style="border-top: 1px solid #ccc!important;">
                            <b-col sm="2" class="mt-3">
                                <p class="p-center">Versand an:</p>
                            </b-col>
                            <b-col class="mt-3">
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="auftrag.email"
                                        :placeholder="auftrag.email"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="2">
                                <p class="p-center">Datum:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="formateDate"
                                        :placeholder="formateDate"
                                >
                                </b-form-input>
                            </b-col>

                            <b-col sm="2">
                                <p class="p-center">Unterschrift:</p>
                            </b-col>
                            <b-col>
                                <b-form-input
                                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                                        disabled
                                        type="text"
                                        v-model="auftrag.sachbearbeiter"
                                        :placeholder="auftrag.sachbearbeiter"
                                >
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-card-group>
            </b-col>
            <b-col md="5" class="mt-3" v-if="auftrag.id !== 'testid'">
                <b-card>
                    <b-row style="gap: 10px">
                            <b-button v-if="editMode" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(true)">
                                &nbsp;Speichern
                            </b-button>
                            <b-button v-if="editMode" variant="warning" class="btn-pill font-lg" v-on:click="toggleEditMode(false)">
                                Abbruch
                            </b-button>
                            <b-button v-if="isEditMode && auftrag.art !== 'DE' && auftrag.a_nehmer === 'Bauhof'" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(undefined)">
                                Ändern
                            </b-button>
                            <b-button v-if="isEditMode && auftrag.art === 'DE'" variant="warning" disabled class="btn-pill font-lg">
                                Abgelehnt
                            </b-button>
                            <b-button v-if="isEditMode && deletable" variant="danger" class="btn-pill font-lg" v-on:click="onDelete">
                                Löschen
                            </b-button>
                        <b-button v-if="isEditMode && shouldShoudFinish" variant="warning" class="btn-pill font-lg" v-on:click="onFinish">
                          Fertigstellen
                        </b-button>
                            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
                                &nbsp;Zurück
                            </b-button>
                    </b-row>
                </b-card>
                <b-card>
                    <div slot="header">
                        Anhänge
                    </div>
                    <b-row>
                        <b-col>
                            <b-list-group>
                                <b-list-group-item
                                        button
                                        class="d-flex justify-content-between align-items-center"
                                        v-for="item in attachments"
                                        v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                                    {{item.file_name}}
                                    <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                                        {{formatBytes(item.file_size)}}
                                    </b-badge>
                                </b-list-group-item>
                            </b-list-group>
                        </b-col>
                    </b-row>
                </b-card>
              <b-card v-if="rooms.length">
                <div slot="header">
                  Chats
                </div>
                <b-row style="gap: 10px; margin-top: -12px; margin-bottom: -12px">
                  <template v-for="(room, roomId, index) in rooms">
                    <task-messaging-button :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben' : 'Auftraggeber'" :new-messages="room.room.unreadCount" @open-chat="showChat = roomId; room.room.unreadCount = 0;"/>
                  </template>
                </b-row>
              </b-card>
                <b-card v-if="auftrag.art !== 'DE'">
                    <div slot="header">
                        Rechnungen
                    </div>
                    <b-row>
                        <b-col>
                            <b-list-group>
                                <b-list-group-item
                                        button
                                        class="d-flex justify-content-between align-items-center"
                                        v-for="item in bills"
                                        v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                                    {{item.file_name}}
                                    <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                                        {{formatBytes(item.file_size)}}
                                    </b-badge>
                                </b-list-group-item>
                            </b-list-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.art === 'DE'">
                    <div slot="header">
                        Ablehnungs-Nachricht
                    </div>
                    <b-row>
                        <b-col>
                            <b-form-textarea id="info-box" ref="infoBox"
                                             class="text-black"
                                             :placeholder="deleteMessage"
                                             rows="6"
                                             max-rows="40"
                                             :disabled="true"
                                             v-model="deleteMessage"

                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.notiz_annahme !== null && auftrag.quittung === 'True'">
                    <div slot="header">
                        Annahme-Nachricht
                    </div>
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                    class="text-black"
                                    :placeholder="annahmeMessage"
                                    rows="6"
                                    max-rows="40"
                                    wrap="hard"
                                    :disabled="true"
                                    v-model="annahmeMessage"

                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.notiz_fertig !== null && auftrag.offen >= 1">
                    <div slot="header">
                        Fertigstellungs-Nachricht
                    </div>
                    <b-row>
                        <b-col>
                            <b-form-textarea
                                             class="text-black"
                                             :placeholder="fertigMessage"
                                             rows="6"
                                             max-rows="40"
                                             wrap="hard"
                                             :disabled="true"
                                             v-model="fertigMessage"

                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="auftrag.lat !== 0.0 && auftrag.lon !== 0.0">
                    <div slot="header">
                        Position
                    </div>
                        <b-row style="margin-bottom: 0">
                            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                                   ref="map_container">
                            </b-col>
                        </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-modal title="Auftrag löschen" size="sm" v-model="delete_modal" @ok="onDeleteOk" ok-variant="danger"
                 ok-title="Löschen" cancel-title="Abbruch">
            Möchten sie diesen Auftrag wirklich löschen?
            Das kann nicht rückgängig gemacht werden.
        </b-modal>
        <beautiful-chat
                v-if="room === null && hasChat && auftrag.a_nehmer === 'Bauhof'"
                :participants="participants"
                :onMessageWasSent="onMessageWasSent"
                :messageList="messageList"
                :newMessagesCount="newMessagesCount"
                :isOpen="isChatOpen"
                :close="closeChat"
                :open="openChat"
                :showEmoji="false"
                :showFile="true"
                :showTypingIndicator="showTypingIndicator"
                :showLauncher="true"
                :showCloseButton="true"
                :colors="colors"
                :alwaysScrollToBottom="alwaysScrollToBottom"
                :messageStyling="messageStyling"
                :disable-user-input="disableChat"
                :placeholder="messagePlaceholder"
                @file_clicked="onFileClicked"
        >
          <template v-slot:header>
            <div class="sc-header--title ">
              Nachrichten:
            </div>
          </template>
            <!--template v-slot:header>
                <p style="margin: auto; text-align: center; font-weight: bold">Teilnehmer:
                    <span style="font-weight: normal">{{participants.map(m=>m.name).join(', ')}}</span>
                </p>
                <account-multiple-plus-icon class="icon-2x" fillColor="#ac121b" style="color: white;
    align-self: center;
    margin-right: 10px;
    margin-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 5px;" :size="40" v-on:click="onAddUsers" @file_clicked=""></account-multiple-plus-icon>

            </template-->
            <template v-slot:user-avatar="{ message, user }">
                <div>
                </div>
            </template>
            <template v-slot:text-message-body="{ message }">
                <p style='font-weight: bold; margin-bottom: 3px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; margin-left: -12px'>
                    {{message.data.meta_name}}:
                </p>
                <p style="margin-left: -12px; margin-bottom: 8px; white-space: pre-wrap;">{{message.data.text}}</p>
                <p style="text-align: right; font-weight: lighter; font-size: 12px; margin-bottom: 0px; margin-top: 8px; margin-right: -12px">
                    {{message.data.meta}}
                </p>
            </template>
            <template v-slot:text-message-toolbox="{ message }">
            </template>
        </beautiful-chat>
        <b-modal size="sm" v-model="showUserList" id="modal-center" centered title="Nutzer einladen"
                 body-class="my-body" @ok="onAddUserToChat">
            <b-table striped bordered hover responsive id="my-table" :items="userList"
                     :fields="userFields" class="mb-0" selectable thead-class="hidden_header"
                     selectedVariant="success"
                     @row-selected="onUserSelect"
                     select-mode="single"
            >
            </b-table>
            <template #modal-footer="{ok, cancel}">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="md" variant="primary" @click="cancel()">
                    Abbrechen
                </b-button>
                <b-button size="md" variant="success" @click="ok()">
                    Einladen
                </b-button>
            </template>
        </b-modal>
        <a ref="show_file" style="display: none;" :href="url" :download="download" target="_blank"></a>
      <template v-for="(room, roomId, index) in rooms">
        <task-messaging @chat-active="activateChat" :key="roomId" :room="room.room" :is-second="index !== 0" v-if="showChat === roomId && room.room != null" :last-online="room.lastOnline" @close-chat="showChat = null" @show-group="room.showChatGroup = true" @show-invite="room.showInvite = true" @user-added="addRoomUser" @leave-room="leaveRoom"/>
        <!--task-messaging-footer :is-active="room.room.is_active" :name="roomId.endsWith(':task_int') ? 'Aufgaben Chat' : 'Auftraggeber Chat'" :is-second="index !== 0" :new-messages="room.room.unreadCount" v-if="room.room !== null && showChat !== roomId" @open-chat="showChat = roomId; room.room.unreadCount = 0;"></task-messaging-footer-->
        <task-messaging-users v-if="room.room !== null" :show-group="room.showChatGroup" :users="room.room.users" @hide-group="room.showChatGroup = false"></task-messaging-users>
        <task-messaging-invite v-if="room.room != null" @hidden="room.showInvite = false" :show-invite="room.showInvite" :room="room.room" @hide-invite="room.showInvite = false" @invite-success="(userid) => {room.room.users.push({_id: userid})}"></task-messaging-invite>
      </template>
    </div>
</template>

<script>
    import {DateTime as LuxonDateTime} from 'luxon'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
    import {decryptAES, decryptFile, decryptMessages, encryptAES, encryptFile} from "../../../shared/crypto";
    import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
    import TaskMessaging from "../../messaging/task_messaging.vue"
    import TaskMessagingFooter from "@/views/messaging/task_messaging_footer.vue";
    import TaskMessagingUsers from "@/views/messaging/task_messaging_user.vue";
    import TaskMessagingInvite from "@/views/messaging/task_messaging_invite.vue";
    import { doc, onSnapshot } from "firebase/firestore";
    import {firestoreDb} from "@/shared/firebase";
    import {listenMessageCounter, PARTICIPANT_PATH} from "@/shared/firebase/database";
    import TaskMessagingButton from "@/views/messaging/task_messaging_button.vue";


    export default {
        name: "auftrag",
        components: {
            AccountMultiplePlusIcon,
          TaskMessaging,
          TaskMessagingFooter,
          TaskMessagingUsers,
          TaskMessagingInvite,
          TaskMessagingButton
        },
        computed: {
            isEditMode() {
                return !this.editMode;
            },
          shouldShoudFinish() {
            return this.showFinish && this.canFinish;
          },
            a_nr() {
                let base = this.auftrag.gi_augr + " / " + this.auftrag.gi_aufisn;
                if (this.auftrag.art === "DE" || this.hadNote) {
                    return base;
                }
                return base + (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "" ? " (" + this.auftrag.notiz_annahme + ")" : "");
            },
            formateDate() {
                if (this.auftrag.datum === null) {
                    return ""
                }
                let event = new Date(this.auftrag.datum.replace('Z', ''));
                let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
                return event.toLocaleDateString('de-DE', options);
            }
        },
        props:{
            onFileClicked: {
                type: Function,
                default: undefined
            },
            onFileOk: {
                type: Function,
                default: undefined
            },
            onAttachment: {
                type: Function,
                default: undefined
            },
            responseError: {
                type: Function,
                default: undefined
            },
            showLoader: {
                type: Function,
                default: undefined
            },
            hideLoader: {
                type: Function,
                default: undefined
            },
          showFinish: {
            type: Boolean,
            default: false
          },
        },
        data: () => {
            return {
              showChatGroup: false,
              showChat: null,
              showInvite: false,
              room: null,
              rooms: {},

              attachments: [],
                bills: [],
                numberMessages: 0,
                auftrag: {
                    id: "testid",
                    a_nehmer: "Bauhof",
                    auftraggeber: "Musterhausen-Public Solutions",
                    ziel: "26.01.2019",
                    ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
                    gi_hh_aus: "9300300.55511010.2-85500",
                    beleg_ex: "2019-0001",
                    gi_auf_ext: "Test Sven",
                    gi_match: "Forstwirtschaft",
                    gi_augr: "0009",
                    gi_aufisn: "000038",
                    gi_memo: "Test vom Sven",
                    email: "info@publicsolutions.de",
                    datum: "",
                    sachbearbeiter: "Administrator",
                },
                deleteMessage: "",
                fertigMessage: "",
                annahmeMessage: "",
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                maxrows: 40,
                editMode: false,
                textBackup: undefined,
                dateBackup: undefined,
                delete_modal: false,
                freigabe: false,
                deletable: false,
                userId: "",

                interval: null,
              listeners: {},
              lastOnline: null,

                // chat specific
                hasChat: false,
                disableChat: false,
                messagePlaceholder: "Nachricht schreiben...",
                participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
                messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
                newMessagesCount: 0,
                isChatOpen: false, // to determine whether the chat window should be open or closed
                showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
                colors: {
                    header: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    launcher: {
                        bg: '#4e8cff'
                    },
                    messageList: {
                        bg: '#ffffff'
                    },
                    sentMessage: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    receivedMessage: {
                        bg: '#eaeaea',
                        text: '#222222'
                    },
                    userInput: {
                        bg: '#f4f7f9',
                        text: '#565867'
                    }
                }, // specifies the color scheme for the component
                alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
                messageStyling: false, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
                showUserList: false,
                userList: [],
                userFields: [{
                    key: 'full_name', label: 'Name', formatter: (value, key, item) => {
                        if (item === null) {
                            return null;
                        }
                        let res = JSON.parse(sessionStorage.getItem(item.id));
                        if (res === null) {
                            return value;
                        }
                        return res.full_name;
                    }
                },],
                selectedUsers: [],
                url: "",
                download: "",
                filename: "",
                a_nehmer: "Bauhof",
                hasContact: false,
                contact: "",
              canFinish: false,
              hadNote: true,
            }
        },
        beforeDestroy: function () {
          for (const property in this.listeners) {
            this.listeners[property].forEach(listener => listener())
            this.listeners[property] = []
          }
            window.clearInterval(this.interval);
        },
        methods: {
          activateChat(roomId) {
            this.rooms[roomId].room.is_active = true;
            if (this.listeners[roomId] === null || this.listeners[roomId] === undefined || this.listeners[roomId].length === 0) {
              this.startListener(roomId, this.userId)
            }
          },
          test(e, arg) {
          },
            print() {
                this.$htmlToPaper('auftrag1', () => {
                });
            },
            toggleEditMode(save) {
                if (save === undefined) {
                    this.textBackup = this.auftrag.gi_memo;
                    this.dateBackup = this.auftrag.ziel_datum;
                } else if (save === false) {
                    this.auftrag.gi_memo = this.textBackup;
                    this.auftrag.ziel_datum = this.dateBackup;
                } else {
                    this.textBackup = this.auftrag.gi_memo;
                    this.dateBackup = this.auftrag.ziel_datum;
                    let data = {
                        id: this.auftrag.id,
                        ziel: this.auftrag.ziel_datum,
                        text: this.auftrag.gi_memo,
                    };
                    if (sessionStorage.getItem("aes") !== null) {
                        this.showLoader();
                        encryptAES(sessionStorage.getItem("aes"), data.text).then(res => {
                            data.text = res;
                            this.sendEdit(data);
                        }).catch(res => {
                        })
                    } else {
                        this.showLoader();
                        this.sendEdit(data)
                    }
                }
                this.editMode = !this.editMode;
            },
            sendEdit(data) {
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/update',
                    data
                ).then(this.onEditResponseOk, this.responseError)
            },
            onEditResponseOk(response) {
                this.hideLoader();
                if (response.status === 200) {
                } else {
                    window.location = Redirect_500;
                }
            },
            onDelete() {
                this.delete_modal = true;
            },
            onDeleteOk() {
                this.delete_modal = false;
                this.showLoader();
                this.$http.delete(
                    Server_URL + '/auftragsbuch/data/delete/' + this.auftrag.id
                ).then(this.onDeleteResponseOk, this.responseError)
            },
            onDeleteResponseOk(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.$router.go(-1);
                } else {
                    window.location = Redirect_500;
                }
            },
          onFinish() {
            this.showLoader();
            this.$http.post(
                Server_URL + '/auftragsbuch/data/finish_temp/' + this.auftrag.id
            ).then(this.responseOkReload, this.responseError)
          },
            onFreigabe(freigeben) {
                this.showLoader();
                let text = freigeben ? "true" : "false";
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/freigabe/' + this.auftrag.id + "?freigeben=" + text, {}
                ).then(this.onFreigabeResponseOk, this.responseError)
            },
            onFreigabeResponseOk(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.freigabe = false;
                } else {
                    window.location = Redirect_500;
                }
            },
            responseOkFetch(response) {
                if (response.status === 200 && response.body.status === "ok") {
                    this.userId = response.body.session.id;
                    let data = response.body.data;
                    if (sessionStorage.getItem("aes") !== null) {
                        this.decryptData(data.data.gi_memo, data.data.notiz_annahme, data.data.notiz_fertig, data.data.art).then(res => {
                            data.data.gi_memo = res[0];
                            data.data.notiz_annahme = res[1];
                            data.data.notiz_fertig = res[2];
                            this.setData(data);
                        }).catch(e => {
                            this.setData(data);
                        });
                    } else {
                        this.setData(data);
                    }
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            async decryptData(memo, annahme, fertig, art) {
                try {
                    if (memo !== null && memo !== "") {
                        memo = await decryptAES(sessionStorage.getItem("aes"), memo);
                    }
                } catch (e) {
                }
                try {
                    if (annahme !== null && annahme !== "") {
                        annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
                    }
                } catch (e) {
                  this.hadNote = false;
                }
                try {
                    if (fertig !== null && fertig !== "") {
                        fertig = await decryptAES(sessionStorage.getItem("aes"), fertig);
                    }
                } catch (e) {
                }
                return [memo, annahme, fertig]
            },
            setData(data) {
                this.auftrag = data.data;
                this.allGroups = data.all_groups;
                this.hideLoader();
                this.contact = "";
                if (this.auftrag.modul === "mm") {
                    let defectData = JSON.parse(this.auftrag.custom_properties);
                   let hasContact = defectData.name !== "" || defectData.email !== "" || defectData.phone_number !== "";
                    if (hasContact) {
                        if (defectData.name !== "") {
                            this.contact += "Name: " + defectData.name + "\n"
                        }
                        if (defectData.email !== "") {
                            this.contact += "Email: " + defectData.email + "\n"
                        }
                        if (defectData.phone_number !== "") {
                            this.contact += "Tel: " + defectData.phone_number + "\n"
                        }
                    }
                }
                this.hasContact = this.contact !== "";
                this.editMode = false;
              this.canFinish = true;

                if (this.auftrag.art === "DE") {
                  this.canFinish = false;
                    this.disableChat = true;
                    this.deleteMessage = this.auftrag.notiz_annahme;
                    this.messagePlaceholder = "Der Auftrag ist abgelehnt."
                }
                if (this.auftrag.offen >= 1) {
                  this.canFinish = false;
                  this.disableChat = true;
                    this.messagePlaceholder = "Der Auftrag ist abgeschlossen."
                }
                if (this.auftrag.notiz_fertig !== null && this.auftrag.notiz_fertig !== "") {
                    this.fertigMessage = this.auftrag.notiz_fertig;
                }
                if (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "") {
                    this.annahmeMessage = this.auftrag.notiz_annahme;
                }
                let res = JSON.parse(sessionStorage.getItem(this.auftrag.auftraggeber));
                if (res !== null) {
                    this.auftrag.auftraggeber = res.username;
                }
                if (this.auftrag.auftraggeber in this.allGroups) {
                    this.auftrag.auftraggeber = this.allGroups[this.auftrag.auftraggeber];
                }

                res = JSON.parse(sessionStorage.getItem(this.auftrag.sachbearbeiter));
                if (res !== null) {
                    this.auftrag.sachbearbeiter = res.first_name + " " + res.surname;
                    this.auftrag.email = res.email;
                }
                this.$nextTick(() => {
                    this.showMapIfNeeded();
                });
                this.attachments = data.attachments;
                this.bills = data.rechnungen;
                this.deletable = data.settings.use_delete;
                if (data.settings.fg_stufe1 && this.auftrag.art === "FG" && this.auftrag.freigabe1 === "-") {
                    this.freigabe = data.user_settings.do_freigabe || this.auftrag.freigeber === data.user_settings.login;
                }
                this.hasChat = data.has_chat && this.auftrag.art !== "SO";
                if (this.hasChat && data.chat_room.roomId === "" && data.chat_room_internal.roomId === "") {
                    for (let i = 0; i < data.authors.length; i++) {
                        let res = JSON.parse(sessionStorage.getItem(data.authors[i].id));
                        if (res !== null) {
                            data.authors[i].name = res.full_name;
                        }
                    }
                    this.participants = data.authors;
                    if (sessionStorage.getItem("aes") !== null) {
                        decryptMessages(sessionStorage.getItem("aes"), data.messages).then(res => {
                            this.messageList = res;
                            if (this.messageList.length !== 0) {
                                this.isChatOpen = true;
                            }
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        }).catch(err => {
                            this.messageList = data.messages;
                            if (this.messageList.length !== 0) {
                                this.isChatOpen = true;
                            }
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        })
                    } else {
                        this.messageList = data.messages;
                        if (this.messageList.length !== 0) {
                            this.isChatOpen = true;
                        }
                        if (this.interval === null) {
                            this.interval = setInterval(this.refresh, 2000);
                        }
                    }
                } else if (this.hasChat) {
                  this.room = {};
                  if (this.hasChat && data.chat_room.roomId !== "") {
                    data.chat_room.unreadCount = 0;
                    this.$set(this.rooms, data.chat_room.roomId,
                        {
                          room: data.chat_room,
                          showChatGroup: false,
                          showChat: false,
                          showInvite: false,
                          lastOnline: null,
                        })
                    this.listeners[data.chat_room.roomId] = [];
                    //this.room = data.chat_room;
                    if (this.rooms[data.chat_room.roomId].room.is_active
                        && !this.rooms[data.chat_room.roomId].room.is_archived) {
                      let found = false;
                      for (let i = 0; i < this.rooms[data.chat_room.roomId].room.users.length; i++) {
                        if (this.rooms[data.chat_room.roomId].room.users[i]._id === this.userId) {
                          found = true;
                          break;
                        }
                      }
                      if (found) {
                        this.startListener(data.chat_room.roomId, this.$cookies.get("ps_user_id"));
                      }
                      if (this.$route.query.open_chat === "task") {
                        this.showChat = data.chat_room.roomId;
                      }
                    }
                  }
                  if (this.hasChat && data.chat_room_internal.roomId !== "") {
                    data.chat_room_internal.unreadCount = 0;
                    this.$set(this.rooms, data.chat_room_internal.roomId,
                        {
                          room: data.chat_room_internal,
                          showChatGroup: false,
                          showChat: false,
                          showInvite: false,
                          lastOnline: null,
                        })
                    this.listeners[data.chat_room_internal.roomId] = [];
                    //this.room = data.chat_room;
                    if (this.rooms[data.chat_room_internal.roomId].room.is_active
                        && !this.rooms[data.chat_room_internal.roomId].room.is_archived) {
                      let found = false;
                      for (let i = 0; i < this.rooms[data.chat_room_internal.roomId].room.users.length; i++) {
                        if (this.rooms[data.chat_room_internal.roomId].room.users[i]._id === this.userId) {
                          found = true;
                          break;
                        }
                      }
                      if (found) {
                        this.startListener(data.chat_room_internal.roomId, this.$cookies.get("ps_user_id"));
                      }
                      if (this.$route.query.open_chat === "int") {
                        this.showChat = data.chat_room_internal.roomId;
                      }
                    }
                  }
                }
            },

          addRoomUser(roomId, u) {
            let found = false;
            for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
              if (this.rooms[roomId].room.users[i]._id === u) {
                found = true;
                break;
              }
            }
            if (!found) {
              this.rooms[roomId].room.users.push({_id: u,  username: ""})
              if (this.userId === u) {
                this.startListener(roomId, u)
              }
            }
          },
          leaveRoom(roomId) {
            for (let i = 0; i < this.rooms[roomId].room.users.length; i++) {
              if (this.rooms[roomId].room.users[i]._id === this.userId) {
                this.rooms[roomId].room.users.splice(i, 1);
                break;
              }
            }
            this.listeners[roomId].forEach(listener => listener());
            this.listeners[roomId] = [];
          },
          startListener(roomId, userId) {
            if (userId === this.$cookies.get("ps_user_id")) {
              if (this.listeners[roomId]) {
                this.listeners[roomId].forEach(listener => listener());
              }
              this.listeners[roomId] = [];
              const unsub = listenMessageCounter(this.$cookies.get("ps_customer_number"),
                  this.rooms[roomId].room.roomId,
                  this.$cookies.get("ps_user_id"),
                  (data) => {
                    this.rooms[roomId].room.unreadCount = data.count_unread;
                    this.rooms[roomId].lastOnline = data.last_active.toDate();
                  });
              this.listeners[roomId].push(unsub)
            }
          },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            back() {
                window.history.back();
            },
            openChat() {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                this.newMessagesCount = 0
            },
            closeChat() {
                // called when the user clicks on the botton to close the chat
                this.isChatOpen = false
            },
            onMessageWasSent(message) {
                // called when the user sends a message
                if (this.interval !== null) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
                if (message.type === "text") {
                    let body = {
                        data_id: this.auftrag.id,
                        data_beleg_ex: this.auftrag.beleg_ex,
                        message: message.data.text,
                    };
                    if (this.messageList.length > 0) {
                        body.create_date = this.messageList[this.messageList.length - 1].data.meta_date;
                    }
                    if (sessionStorage.getItem("aes") !== null) {
                        encryptAES(sessionStorage.getItem("aes"), body.message).then(res => {
                            body.plain_text = body.message;
                            body.plain_name = JSON.parse(sessionStorage.getItem(this.userId)).full_name;
                            body.message = res;
                            this.$http.post(
                                Server_URL + '/auftragsbuch/data/message', body
                            ).then(this.onNewMessages, this.responseError)
                        })
                    } else {
                        this.$http.post(
                            Server_URL + '/auftragsbuch/data/message', body
                        ).then(this.onNewMessages, this.responseError)
                    }
                } else {
                    if (sessionStorage.getItem("aes") !== null) {
                        this.showLoader();
                        const reader = new FileReader();
                        reader.addEventListener('load', (event) => {
                            let buf = new Uint8Array(event.target.result);
                            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
                                const b = new Blob([res], {type: message.data.file.type});
                                let lastDate = "";
                                if (this.messageList.length > 0) {
                                    lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
                                }
                                let formData = new FormData();
                                formData.append('upload_file', b, message.data.file.name);
                                this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                                    +this.$route.params.id+"?plain_name=" + JSON.parse(sessionStorage.getItem(this.userId)).full_name + "&last_date=" + lastDate,
                                    formData,
                                    {
                                        headers: {
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    }
                                ).then(this.onNewMessages, this.responseError)
                            }).catch(err => {
                                this.hideLoader();
                            })
                        });
                        reader.readAsArrayBuffer(message.data.file);
                    } else {
                        let lastDate = "";
                        if (this.messageList.length > 0) {
                            lastDate = this.messageList[this.messageList.length - 1].data.meta_date;
                        }
                        let formData = new FormData();
                        formData.append('upload_file',message.data.file);
                        this.$http.post( Server_URL+'/auftragsbuch/data/file_message/'
                            +this.$route.params.id+"?plain_name=xxx"+"&last_date=" + lastDate,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(this.onNewMessages, this.responseError)
                    }
                }
            },
            onNewMessages(response) {
                if (response.status === 200) {
                    if (response.body.authors !== undefined) {
                        for (let i = 0; i < response.body.authors.length; i++) {
                            let found = false;
                            for (let j = 0; j < this.participants.length; j++) {
                                if (this.participants[j].id === response.body.authors[i].id) {
                                    found = true;
                                    break
                                }
                            }
                            if (!found) {
                                let res = JSON.parse(sessionStorage.getItem(response.body.authors[i].id));
                                if (res !== null) {
                                    response.body.authors[i].name = res.full_name;
                                }
                                this.participants.push(response.body.authors[i]);
                            }
                        }
                    }
                    if (sessionStorage.getItem("aes") !== null) {
                        decryptMessages(sessionStorage.getItem("aes"), response.body.messages).then(res => {
                            for (let i = 0; i < res.length; i++) {
                                this.messageList.push(res[i]);
                            }
                            this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + res.length;
                            if (this.interval === null) {
                                this.interval = setInterval(this.refresh, 2000);
                            }
                        })
                    } else {
                        for (let i = 0; i < response.body.messages.length; i++) {
                            this.messageList.push(response.body.messages[i]);
                        }
                        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + response.body.messages.length;
                        if (this.interval === null) {
                            this.interval = setInterval(this.refresh, 2000);
                        }
                    }
                    this.hideLoader();
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            refresh() {
                let url = Server_URL + '/auftragsbuch/data/messages/' + this.auftrag.id;
                if (this.messageList.length !== 0) {
                    url += "?last_date=" + encodeURIComponent(this.messageList[this.messageList.length - 1].data.meta_date);
                }
                this.$http.get(
                    url
                ).then(this.onNewMessages, this.responseErrorTrap)
            },
          responseErrorTrap(response) {
            if (response.status === 401) {
              window.location = Redirect_Login;
            } else {
              console.log(response);
            }
          },
            onAddUsers() {
                this.showUserList = true;
                this.selectedUsers = [];
                this.showLoader();
                this.$http.get(
                    Server_URL + '/auftragsbuch/data/users'
                ).then(this.responseOkFetchUsers, this.responseError)
            },
            responseOkFetchUsers(response) {
                if (response.status === 200) {
                    this.hideLoader();
                    let users = [];
                    for (let i = 0; i < response.body.length; i++) {
                        let found = false;
                        for (let j = 0; j < this.participants.length; j++) {
                            if (response.body[i].id === this.participants[j].id) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            users.push(response.body[i]);
                        }
                    }
                    this.userList = users;
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            onUserSelect(items) {
                this.selectedUsers = items;
            },
            onAddUserToChat() {
                if (this.selectedUsers.length === 0) {
                    return
                }
                let payload = {};
                if (sessionStorage.getItem("aes") !== null) {
                    payload = {
                        data_id: this.auftrag.id,
                        plain_name: JSON.parse(sessionStorage.getItem(this.userId)).full_name,
                        recipient_id: this.selectedUsers[0].id,
                        recipient_plain_name: JSON.parse(sessionStorage.getItem(this.selectedUsers[0].id)).full_name,
                    }
                } else {
                    payload = {
                        data_id: this.auftrag.id,
                        recipient_id: this.selectedUsers[0].id,
                        recipient_plain_name: this.selectedUsers[0].full_name,
                    }
                }
                this.showLoader();
                this.$http.post(
                    Server_URL + '/auftragsbuch/data/message/invite', payload
                ).then(this.responseOkInvite, this.responseError)
            },
            responseOkInvite(response) {
                if (response.status === 200) {
                    this.hideLoader();
                    this.participants.push(response.body);
                } else {
                    this.hideLoader();
                    window.location = Redirect_500;
                }
            },
            responseOkReload() {
                this.$http.get(
                    Server_URL + '/auftragsbuch/data/single/' + this.$route.params.id
                ).then(this.responseOkFetch, this.responseError)
            },
            showMapIfNeeded() {

                if (this.map !== undefined || this.auftrag.lat === 0.0 || this.auftrag.lon === 0.0) {
                    return;
                }

                mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                this.map = new mapboxgl.Map({
                    container: 'map_container',
                    style: 'mapbox://styles/mapbox/outdoors-v11',
                    center: [this.auftrag.lon, this.auftrag.lat],
                    zoom: 18,
                    minZoom: 5,
                    maxPitch: 0,
                    attributionControl: false
                });

                this.map.addControl(new ZoomControl(), 'bottom-right');
                const languageControl = new LanguageControl({
                    language: 'de',
                });
                this.map.addControl(languageControl);

                this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

                this.marker = null;
                this.geojson = {};
                this.map.on('load', this.mapLoad);
            },
            mapLoad() {
                setTimeout(() => {
                    if (this.marker === null) {
                        let el = document.createElement('div');
                        el.className = 'marker';

                        this.marker = new mapboxgl.Marker({
                            element: el,
                            anchor: 'center',
                        })
                            .setLngLat([this.auftrag.lon, this.auftrag.lat])
                            .addTo(this.map);
                    }
                    this.map.resize();
                    this.hideLoader()
                });
            },
        }
    }
</script>

<style>
    .marker {
        background-image: url('../../../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .sc-message {
        width: 480px;
    }

    .sc-message--text .sc-message--toolbox {
        display: none;
    }

    .sc-launcher.opened :before {
        box-shadow: none;
    }

    .sc-launcher.opened:before {
        box-shadow: none !important;
    }

    .sc-chat-window {
      border: 1px solid lightgray !important;
      width: 520px !important;
      z-index: 5;
    }

    .sc-launcher {
      z-index: 5;
    }

    .sc-header {
      min-height: unset !important;
    }

    .sc-user-input {
        border-top: 1px solid lightgray !important;

    }

    .sc-user-input--text {
        width: 450px !important;
    }

    .sc-header--close-button {
        margin-left: 0 !important;
    }

    .my-body {
        padding: 0 !important;
    }

    .hidden_header {
        display: none;
    }

    .sc-user-input--file-icon-wrapper {
        margin-bottom: 0;
    }
</style>

<style scoped>

    .form-control:disabled, .form-control[disabled] {
        color: black !important;
    }

    .text-black {
        color: black;
    }

    .p-center {
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0;
    }

    .bold-text {
        font-weight: bold;
    }

    ::placeholder { /* Firefox, Chrome, Opera */
        color: black;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: black;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: black;
    }

</style>
